import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TicketService } from '../../services/ticket.service';
import { CondominiumService } from '../../services/condominium.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-ticket-create',
    templateUrl: './ticket-create.component.html',
    styleUrls: ['./ticket-create.component.sass'],
    standalone: false
})
export class TicketCreateComponent implements OnInit {
  ticketForm: UntypedFormGroup;
  condominiumId: number | null = null;
  isLoading = false;

  constructor(
    private ticketService: TicketService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar
  ) {
    this.ticketForm = this.fb.group({
      title: ['', Validators.required],
      body: ['', Validators.required],
      priority: ['MEDIUM', Validators.required],
      status: ['OPEN', Validators.required]
    });
  }

  ngOnInit(): void {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
  }

  onSubmit(): void {
    if (this.ticketForm.valid && this.condominiumId) {
      this.isLoading = true;
      const ticketData = {
        ...this.ticketForm.value,
        condominiumId: this.condominiumId
      };

      this.ticketService.createTicket(ticketData).subscribe({
        next: () => {
          this.snackBar.open('Ticket created successfully!', 'Close', { duration: 3000 });
          this.router.navigate([`/condominium/${this.condominiumId}/tickets`]);
        },
        error: (error) => {
          console.error('Error creating ticket:', error);
          this.snackBar.open('Error creating ticket', 'Close', { duration: 3000 });
          this.isLoading = false;
        }
      });
    }
  }

  onCancel(): void {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/tickets`]);
    } else {
      this.router.navigate(['/condominiums']);
    }
  }
}
